import * as types from './mutation-types'

export default {
    [types.BOOTSTRAP_COMMUNICATIONS](state, communications) {
        state.communications = communications
    },
    [types.SET_TOTAL_COMMUNICATIONS](state, totalCommunications) {
        state.totalCommunications = totalCommunications
    },
    [types.ADD_COMMUNICATION](state, data) {
        state.communications.push(data.communication)
    },
    [types.SET_SELECTED_COMMUNICATIONS](state, data) {
        state.selectedCommunications = data
    },
    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
    [types.UPDATE_COMMUNICATION](state, data) {
        let communication = state.communications.findIndex(communication => communication.id === data.communication.id)

        state.communications[communication] = data.communication
    },

}